import React, {useEffect, createContext, useReducer} from 'react';
import 'materialize-css/dist/css/materialize.min.css';
import "./App.css"
import NavBar from './components/navbar';
import {BrowserRouter as Router, Route, Switch, useHistory} from "react-router-dom"
import Home from './components/screens/Home';
import Login from './components/screens/Login';
import Profile from './components/screens/Profile';
import Signup from './components/screens/Signup';
import CreatePost from './components/screens/CreatePost';
import UserProfile from './components/screens/UserProfile';
import FollowingUserPost from './components/screens/followingUserPost';
import UpdateProfile from './components/screens/UpdateProfile';
import Reset from './components/screens/Reset';
import NewPassword from './components/screens/NewPassword';
import PageNotFound from './components/screens/PageNotFound';
import SinglePost from './components/screens/ViewSinglePost';
import SinglePost2 from './components/screens/ViewsinglePost2';
import ActivcateAccount from './components/screens/ActivationEmail';
import AdminRoute from './components/Admin/AdminRoute';
import DeleteUser from './components/Admin/DeleteUser';
export const UserContext = createContext();



const Routing = () => {
  const history = useHistory();
  const user = JSON.parse(localStorage.getItem("jwt"))
  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("jwt"))
    if(user){
      
    }
    else{
      if(history.location.pathname.startsWith("/reset") || history.location.pathname.startsWith("/post")|| history.location.pathname.startsWith("/authentication")){
        
      }
      else{
        history.push("/login")
      }
      
    }
  }, [])
    return(
      <Switch>
      <Route path="/" component={Home} exact></Route>
      <Route path="/signup" component={Signup} exact></Route>
      <Route path="/login" component={Login} exact></Route>
      <Route path="/profile" component={Profile} exact></Route>
      <Route path="/create" component={CreatePost} exact></Route>
      <Route path="/profile/:id" component={UserProfile} exact></Route>
      <Route path="/myfollowerspost" component={FollowingUserPost} exact></Route>
      <Route path="/updateprofile" component={UpdateProfile} exact></Route>
      <Route path="/reset" component={Reset} exact></Route>
      <Route path="/reset/:token1" component={NewPassword} exact></Route>
      <Route path="/post/:postId" component={user ? SinglePost : SinglePost2} exact></Route>
      <Route path="/authentication/activate/:token" component={ActivcateAccount} exact></Route>
      <AdminRoute path="/admin/updateuser" component={DeleteUser}></AdminRoute>
      <Route component={PageNotFound}></Route>
      </Switch>
    )
}
function App() {
  
  return (
    
    <Router>
      <NavBar/>
      <Routing/>
    </Router>
    
  );
}

export default App;
